/*
    EVENTS:

reload-ns-loader -> global event for reload ns-loader
*/

/* data model toolbar event

on-create-new-model: {

    emmeteur: [src/components/page/Instance/DataModel/data-model-toolbar.vue]
    receiver: [
        src/components/page/Instance/DataModel/SchemaEditor/index.vue,
    ]
}

export-data-model{

    emmeteur: [src/components/page/Instance/DataModel/data-model-toolbar.vue]
    receiver: [
        src/components/page/Instance/DataModel/index.vue,
    ]
}
import-data-model{

    emmeteur: [src/components/page/Instance/DataModel/data-model-toolbar.vue]
    receiver: [
        src/components/page/Instance/DataModel/index.vue,
    ]
}

on-save-data-model {
    emmeteur: [src/components/page/Instance/DataModel/index.vue]
    receiver: [
        src/components/page/Instance/Permissions/index.vue,
    ]
}

update-data-model {
    emmeteur: [src/components/page/Instance/Permissions/index.vue]
    receiver: [
        src/components/page/Instance/DataModel/index.vue,
    ]
}

save-schema {
    emmeteur: [src/components/page/Instance/DataModel/propertie-form.vue]
    receiver: [
        src/components/page/Instance/DataModel/index.vue,
    ]
}
*/



import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./src/eventBus.js